/* eslint class-methods-use-this: "off" */
import GridMouseHandler from "../GridMouseHandler.js";
/**
 * Used to eat the mouse event in the bottom right corner of the scroll bar
 */
class GridScrollBarCornerMouseHandler extends GridMouseHandler {
  isInCorner(gridPoint, grid) {
    var theme = grid.getTheme();
    var scrollBarSize = theme.scrollBarSize;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var x = gridPoint.x,
      y = gridPoint.y;
    var width = metrics.width,
      height = metrics.height,
      hasVerticalBar = metrics.hasVerticalBar,
      hasHorizontalBar = metrics.hasHorizontalBar;
    return scrollBarSize > 0 && hasVerticalBar && hasHorizontalBar && x >= width - scrollBarSize && y >= height - scrollBarSize && x <= width && y <= height;
  }
  onDown(gridPoint, grid) {
    return this.isInCorner(gridPoint, grid);
  }
  onUp(gridPoint, grid) {
    return this.isInCorner(gridPoint, grid);
  }
  onClick(gridPoint, grid) {
    return this.isInCorner(gridPoint, grid);
  }
}
export default GridScrollBarCornerMouseHandler;
//# sourceMappingURL=GridScrollBarCornerMouseHandler.js.map